import type { ResourceLanguage } from "i18next";

import { Tk } from "../translation-key";
import { tk } from "../utils";

const RESOURCES = {
  translation: {
    EN: "eng",
    UK: "ukr",
    DE: "ger",
    SK: "slov",
    RU: "rus",
    ENGLISH: "english",
    UKRAINIAN: "ukrainian",
    GERMAN: "german",
    SLOVAK: "slovak",
    RUSSIAN: "russian",
    ORDER_ACCEPTANCE: "order acceptance",
    INTRODUCTION: "introduction",
    CALCULATOR: "calculator",
    PROFESSIONAL_RELOCATION_SERVICES_IN_SWITZERLAND:
      "professional relocation services in Switzerland",
    RELIABLE_LOADERS_EXPERIENCED_DRIVERS_AND_THE_BEST_PRICE_ON_THE_MARKET:
      "reliable loaders, experienced drivers and the best price on the market",
    CALCULATE_THE_COST: "calculate the cost",
    SUPPORT: "support",
    RELIABLE_SERVICE: "reliable service",
    WHY_CUSTOMERS_CHOOSE_US: "why customers choose us",
    FAVORABLE_PRICES: "favorable prices",
    THE_BEST_PRICES_ON_THE_MARKET_WITHOUT_HIDDEN_FEES:
      "the best prices on the market without hidden fees",
    FAST_CAR_DELIVERY: "fast car delivery",
    TRANSPORT_WILL_ARRIVE_WITHIN_30_60_MINUTES: "transport will arrive within 30-60 minutes",
    EXPERIENCED_LOADERS: "experienced loaders",
    QUALIFIED_EMPLOYEES_WITH_EXTENSIVE_WORK_EXPERIENCE:
      "qualified employees with extensive work experience",
    GUARANTEE_OF_PRESERVATION: "guarantee of preservation",
    YOUR_BELONGINGS_ARE_SAFE_THROUGHOUT_THE_MOVE: "your belongings are safe throughout the move",
    OUR_SERVICES: "our services",
    WE_OFFER_A_FULL_RANGE_OF_SERVICES_FOR_MOVING_APARTMENTS_OFFICES_AND_INDUSTRIAL_FACILITIES:
      "we offer a full range of services for moving apartments, offices and industrial facilities",
    APARTMENT_MOVING: "apartment moving",
    OFFICE_RELOCATION: "office relocation",
    INDUSTRIAL_RELOCATION: "industrial relocation",
    MORE_DETAILS: "more details",
    MOVING_COST: "moving cost",
    FLEXIBLE_PRICING_SYSTEM_FOR_DIFFERENT_ORDERS: "flexible pricing system for different orders",
    MINIMUM: "minimum",
    FROM_PRICE: "from {{price}}",
    CARGO_GAZELLE: "cargo gazelle",
    TRUCK: "truck",
    T: "t",
    NUMBER_OF_LOADERS: "number of loaders",
    POPULAR: "popular",
    PRICE_FOR_A_1_ROOM_APARTMENT: "price for a 1-room apartment",
    PRICE_FOR_A_HOUSE_WITH_AN_AREA_OF_UP_TO_100_M: "price for a house with an area of up to 100 m²",
    PRICE_FOR_AN_OFFICE_WITH_AN_AREA_OF_UP_TO_50_M:
      "price for an office with an area of up to 50 m²",
    ORDER: "order",
    [tk(Tk.ORDER, { plural: "one" })]: "order",
    [tk(Tk.ORDER, { plural: "other" })]: "orders",
    COST_CALCULATOR: "cost calculator",
    CALCULATE_THE_COST_OF_YOUR_MOVE: "calculate the cost of your move",
    SELECT_SERVICES: "select services",
    TRANSPORTATION: "transportation",
    PACKING_THINGS: "packing things",
    LOADING_UNLOADING: "loading/unloading",
    VEHICLE: "vehicle",
    YOUR_ORDER: "your order",
    TOTAL: "total",
    OUR_CUSTOMERS_REVIEWS: "our customers' reviews",
    HOW_DO_WE_WORK: "how do we work",
    PREPARATION: "preparation",
    MOVING: "moving",
    YOU_LEAVE_A_REQUEST_ON_THE_WEBSITE_OR_CALL_OUR_MANAGER_WILL_CONTACT_YOU_WITHIN_15_MINUTES:
      "you leave a request on the website or call. Our manager will contact you within 15 minutes",
    WE_CALCULATE_THE_COST_AGREE_ON_A_TIME_BRING_PACKING_MATERIALS_AND_PREPARE_THE_TEAM:
      "we calculate the cost, agree on a time, bring packing materials, and prepare the team",
    OUR_SPECIALISTS_ARRIVE_AT_THE_APPOINTED_TIME_CAREFULLY_PACK_LOAD_AND_TRANSPORT_YOUR_BELONGINGS:
      "our specialists arrive at the appointed time, carefully pack, load, and transport your belongings",
    CONTACT_US: "contact us",
    ADDRESS: "address",
    [tk(Tk.ADDRESS, { plural: "one" })]: "address",
    [tk(Tk.ADDRESS, { plural: "other" })]: "addresses",
    PHONE: "phone",
    [tk(Tk.PHONE, { plural: "one" })]: "phone",
    [tk(Tk.PHONE, { plural: "other" })]: "phones",
    EMAIL: "email",
    WORK_SCHEDULE: "work schedule",
    SOCIAL_NETWORKS: "social networks",
    WRITE_TO_US: "write to us",
    REQUEST_SUBJECT: "request subject",
    I_D_LIKE_TO_ORDER: "i'd like to order",
    QUESTIONS_ABOUT_SERVICES: "questions about services",
    OTHER: "other",
    MESSAGE: "message",
    SEND: "send",
    CONVENIENT_FAST_RELIABLE: "convenient, fast, reliable",
    ALL_RIGHTS_RESERVED: "all rights reserved",
    THERE_WAS_AN_ERROR_LOADING_DATA: "there was an error loading data",
    TRY_AGAIN: "try again",
    ORDER_A_MOVE: "order a move",
    CONTACT_PERSON: "contact person",
    FULL_NAME: "full name",
    CITY: "city",
    FLOOR: "floor",
    IS_THERE_AN_ELEVATOR: "is there an elevator",
    DESCRIPTION_OF_CARGO: "description of cargo",
    FROM_WHERE: "from where",
    TO: "to",
    SEND_AN_APPLICATION: "send an application",
    DOES_NOT_MATCH_FORMAT: "does not match {{format}} format",
    NOT_ENOUGH_CHARACTERS_AT_LEAST_N_REQUIRED:
      "not enough characters, at least {{count}} is required",
    [tk(Tk.NOT_ENOUGH_CHARACTERS_AT_LEAST_N_REQUIRED, { plural: "one" })]:
      "not enough characters, at least {{count}} is required",
    [tk(Tk.NOT_ENOUGH_CHARACTERS_AT_LEAST_N_REQUIRED, { plural: "other" })]:
      "not enough characters, at least {{count}} are required",
    WHAT_IS_INCLUDED_IN_THE_SERVICE: "what is included in the service",
    NO_INFORMATION_PROVIDED_AT_THIS_TIME: "no information provided at this time",
    MUST_BE_A_NUMBER: "must be a number",
    MUST_BE_GREATER_THAN_N: "must be greater than {{count}}",
    MUST_BE_AT_LEAST_N: "must be at least {{count}}",
    FIELD_CANNOT_BE_EMPTY: "field cannot be empty",
    FIELD_MUST_CONTAIN_AT_LEAST_N_CHARACTERS: "field must contain at least {{count}} characters",
    FIELD_MUST_MATCH_FORMAT: "field must match {{format}} format",
    FIELD_MUST_CONTAIN_A_NUMBER: "field must contain a number",
    VALUE_MUST_BE_GREATER_THAN_N: "value must be greater than {{count}}",
    MINIMUM_VALUE_IS_N: "minimum value is {{count}}",
    FIELD_MUST_CONTAIN_NO_MORE_THAN_N_CHARACTER:
      "field must contain no more than {{count}} characters",
    VALUE_MUST_BE_LESS_THAN_N: "value must be less than {{count}}",
    MAXIMUM_VALUE_IS_N: "maximum value is {{count}}",
    PICK_A_DATE: "pick a date",
    HOW_DID_YOU_HEAR_ABOUT_US: "how did you hear about us",
    PLEASE_TELL_US_HOW_YOU_FOUND_OUT_ABOUT_US: "please tell us how you found out about us",
    WEB_SEARCH: "web search",
    FRIEND_RECOMMENDATIONS: "friend recommendations",
    SOCIAL_MEDIA: "social media",
    ADVERTISING: "advertising",
    GENDER: "gender",
    MALE: "male",
    FEMALE: "female",
    UNDETERMINED: "undetermined",
    POSTAL_CODE: "postal code",
    BUILDING_TYPE: "building type",
    PRIVATE_HOUSE: "private house",
    APARTMENT: "apartment",
    OFFICE: "office",
    AREA: "area",
    M: "m",
    NUMBER_OF_ROOMS: "number of rooms",
    IS_THERE_AN_ATTIC: "is there an attic",
    IS_THERE_A_BASEMENT: "is there a basement",
    PLANNED_MOVING_DATE: "planned moving date",
    SELECTED_SERVICES: "selected services",
    MENU: "menu",
    DASHBOARD: "dashboard",
    DOCUMENTATION: "documentation",
    ADMINISTRATOR: "administrator",
    A: "a",
    MY_PROFILE: "my profile",
    ORDER_MANAGEMENT: "order management",
    SERVICE_MANAGEMENT: "service management",
    USER_MANAGEMENT: "user management",
    NEW: "new",
    COMPLETED: "completed",
    REVENUE: "revenue",
    SINCE_YESTERDAY: "since yesterday",
    LATEST_ORDERS: "latest orders",
    SHOW_ALL: "show all",
    ID: "id",
    CLIENT: "client",
    DATE: "date",
    SUM: "sum",
    STATUS: "status",
    IN_PROGRESS: "in progress",
    ASSIGNED: "assigned",
    CANCELLED: "cancelled",
    ANNUAL_REVENUE: "annual revenue",
    ADD_ORDER: "add order",
    FILTER: "filter",
    WITH_ELEVATOR: "with elevator",
    WITHOUT_ELEVATOR: "without elevator",
    EDIT: "edit",
    DELETE: "delete",
    YES: "yes",
    NO: "no",
    ADD_A_SERVICE: "add a service",
    NAME: "name",
    CATEGORY: "category",
    [tk(Tk.CATEGORY, { plural: "one" })]: "category",
    [tk(Tk.CATEGORY, { plural: "other" })]: "categories",
    PRICE: "price",
    ACTIVE: "active",
    INACTIVE: "inactive",
    ADD_USER: "add user",
    EMPLOYEE: "employee",
    USER: "user",
    [tk(Tk.USER, { plural: "one" })]: "user",
    [tk(Tk.USER, { plural: "other" })]: "users",
    ROLE: "role",
    [tk(Tk.ROLE, { plural: "one" })]: "role",
    [tk(Tk.ROLE, { plural: "other" })]: "roles",
    VIEW: "view",
    ORDER_INFORMATION: "order information",
    CREATION_DATE: "creation date",
    TOTAL_COST: "total cost",
    QUANTITY: "quantity",
    INFORMATION_NOT_PROVIDED: "information not provided",
    CHANGE_STATUS: "change status",
    ACTIONS: "actions",
    PRINT: "print",
    STATUS_SUCCESSFULLY_CHANGED: "status successfully changed",
    FAILED_TO_CHANGE_STATUS: "failed to change status",
    THIS_ORDER_WAS_NOT_FOUND: "this order was not found",
    SERVICE_CATEGORY_MANAGEMENT: "service category management",
    DESCRIPTION: "description",
    ADD_CATEGORY: "add category",
    THIS_ACTION_CANNOT_BE_UNDONE: "this action cannot be undone",
    NO_RECORDS_FOUND_IN_THE_DATABASE: "no records found in the database",
    NUMBER: "number",
    SIZE: "size",
    CREATE: "create",
    LANGUAGE: "language",
    SELECT_THE_LANGUAGE_IN_WHICH_YOU_WANT_TO_PROVIDE_DATA_FOR_FILLING_IN:
      "select the language in which you want to provide data for filling in",
    SAVE: "save",
    RESET: "reset",
    IMAGE: "image",
    ADD: "add",
    HYPERLINK: "hyperlink",
    CHANGES_SAVED_SUCCESSFULLY: "changes saved successfully",
    FAILED_TO_SAVE_CHANGES: "failed to save changes",
    SERVICE: "service",
    [tk(Tk.SERVICE, { plural: "one" })]: "service",
    [tk(Tk.SERVICE, { plural: "other" })]: "services",
    THE_DATE_MUST_NOT_BE_IN_THE_PAST: "the date must not be in the past",
    ORDER_REQUEST: "order request",
    PASSWORD: "password",
    ADMINISTRATIVE_PANEL: "administrative panel",
    FORGOT_YOUR_PASSWORD: "forgot your password",
    REMEMBER_ME: "remember me",
    SIGN_IN: "sign in",
    FAILED_TO_LOG_IN: "failed to log in",
    AN_UNEXPECTED_ERROR_OCCURRED_PLEASE_TRY_AGAIN_LATER:
      "an unexpected error occurred, please try again later",
    INCORRECT_EMAIL_ADDRESS_AND_OR_PASSWORD: "incorrect email address and/or password",
    SIGN_OUT: "sign out",
    FIRST_NAME: "first name",
    LAST_NAME: "last name",
    THIS_EMAIL_ADDRESS_IS_ALREADY_IN_USE_BY_ANOTHER_USER:
      "this email address is already in use by another user",
    SUBJECT: "subject",
    BODY: "body",
    SENDING_AN_EMAIL: "sending an email",
    EMAIL_SENT_SUCCESSFULLY: "email sent successfully",
    SOME_OF_THE_SELECTED_ROLES_DO_NOT_EXIST: "some of the selected roles do not exist",
    INQUIRY: "inquiry",
    [tk(Tk.INQUIRY, { plural: "one" })]: "inquiry",
    [tk(Tk.INQUIRY, { plural: "other" })]: "inquiries",
    FAILED_TO_LOAD_YOUR_DATA: "failed to load your data",
    ACCESS_TO_THE_PAGE_IS_DENIED: "access to the page is denied",
    ONLY_ADMINISTRATORS_HAVE_ACCESS_TO_THIS_PAGE: "only administrators have access to this page",
    ONLY_ADMINISTRATORS_AND_EMPLOYEES_HAVE_ACCESS_TO_THIS_PAGE:
      "only administrators and employees have access to this page",
    YOU_ARE_ALREADY_LOGGED_IN: "you are already logged in",
    AUTHENTICATION_SESSION_EXPIRED: "authentication session expired",
    ORDERED_SERVICES: "ordered services",
    THE_DATE_MUST_NOT_BE_EARLIER_THAN_THE_CURRENT_MOMENT:
      "the date must not be earlier than the current moment",
    YOU_HAVE_NOT_SELECTED_ANY_SERVICES: "you have not selected any services",
    VALUE_MUST_MATCH_PHONE_NUMBER_FORMAT: "value must match phone number format",
    "ENTER_THE_VALUE_IN_INTERNATIONAL_PHONE_NUMBER_FORMAT_I_E_...":
      "enter the value in international phone number format, i.e. +, country code and the phone number itself (without spaces), for example: +41791234567",
    ACCOUNT_LOGIN: "account login",
    "PROFESSIONAL_ORGANIZATION_OF_MOVING_TO_FROM_...":
      "professional organization of moving to/from an apartment, office or private house in Switzerland. Fast, safe and hassle-free. Plan your move with us!",
    "MOVING_IN_SWITZERLAND_APARTMENT_MOVING_OFFICE...":
      "moving in Switzerland, apartment moving, office moving, private house moving, apartment moving, furniture transportation in Switzerland, moving services",
    INQUIRY_MANAGEMENT: "inquiry management",
    RESOLVED: "resolved",
    ADMINISTRATOR_COMMENT: "administrator comment",
    RESOLVE: "resolve",
    INQUIRY_RESOLUTION: "inquiry resolution",
    REVIEW_MANAGEMENT: "review management",
    RATING: "rating",
    PROS: "pros",
    CONS: "cons",
    TEXT: "text",
    REVIEW: "review",
    [tk(Tk.REVIEW, { plural: "one" })]: "review",
    [tk(Tk.REVIEW, { plural: "other" })]: "reviews",
    FAILED_TO_OPEN_PRINT_WINDOW: "failed to open print window",
    NEW_ORDER: "new order",
    NEW_INQUIRY: "new inquiry",
    NEW_REVIEW: "new review",
    SOMETHING_HAPPENED: "something happened",
    MARK_AS_READ: "mark as read",
    FAILED_TO_MARK_NOTIFICATION_AS_READ: "failed to mark notification as read",
    MARK_ALL_AS_READ: "mark all as read",
    FAILED_TO_MARK_ALL_NOTIFICATIONS_AS_READ: "failed to mark all notifications as read",
    NOTIFICATION: "notification",
    ORDER_CREATION: "order creation",
    SERVICE_CREATION: "service creation",
    CATEGORY_CREATION: "category creation",
    USER_CREATION: "user creation",
    ORDER_CREATED: "order created",
    SERVICE_CREATED: "service created",
    CATEGORY_CREATED: "category created",
    USER_CREATED: "user created",
    INQUIRY_CREATED: "inquiry created",
    REVIEW_CREATED: "review created",
    ORDER_REQUEST_CREATED: "order request created",
    FAILED_TO_CREATE_ORDER: "failed to create order",
    FAILED_TO_CREATE_SERVICE: "failed to create service",
    FAILED_TO_CREATE_CATEGORY: "failed to create category",
    FAILED_TO_CREATE_USER: "failed to create user",
    FAILED_TO_CREATE_INQUIRY: "failed to create inquiry",
    FAILED_TO_CREATE_REVIEW: "failed to create review",
    FAILED_TO_CREATE_ORDER_REQUEST: "failed to create order request",
    ORDER_DELETED: "order deleted",
    SERVICE_DELETED: "service deleted",
    CATEGORY_DELETED: "category deleted",
    USER_DELETED: "user deleted",
    REVIEW_DELETED: "review deleted",
    INQUIRY_DELETED: "inquiry deleted",
    FAILED_TO_DELETE_ORDER: "failed to delete order",
    FAILED_TO_DELETE_SERVICE: "failed to delete service",
    FAILED_TO_DELETE_CATEGORY: "failed to delete category",
    FAILED_TO_DELETE_USER: "failed to delete user",
    FAILED_TO_DELETE_REVIEW: "failed to delete review",
    FAILED_TO_DELETE_INQUIRY: "failed to delete inquiry",
    ORDER_NOT_FOUND: "order not found",
    SERVICE_NOT_FOUND: "service not found",
    CATEGORY_NOT_FOUND: "category not found",
    USER_NOT_FOUND: "user not found",
    REVIEW_NOT_FOUND: "review not found",
    INQUIRY_NOT_FOUND: "inquiry not found",
    NOTIFICATION_NOT_FOUND: "notification not found",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_ORDER: "Are you sure you want to delete the order?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_SERVICE: "Are you sure you want to delete the service?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_CATEGORY: "Are you sure you want to delete the category?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_USER: "Are you sure you want to delete the user?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_REVIEW: "Are you sure you want to delete the review?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_INQUIRY: "Are you sure you want to delete the inquiry?",
    ORDER_EDITING: "order editing",
    SERVICE_EDITING: "service editing",
    CATEGORY_EDITING: "category editing",
    USER_EDITING: "user editing",
    REVIEW_EDITING: "review editing",
    INQUIRY_EDITING: "inquiry editing",
    EDITING_ORDERED_SERVICES: "editing ordered services",
    FAILED_TO_PRINT_ORDER: "failed to print order",
    FAILED_TO_SEND_EMAIL: "failed to send email",
    FAILED_TO_SIGN_OUT: "failed to sign out",
    CONTACT: "contact",
    [tk(Tk.CONTACT, { plural: "one" })]: "contact",
    [tk(Tk.CONTACT, { plural: "other" })]: "contacts",
    [tk(Tk.CONTACT, { context: "infinitive" })]: "contact",
    YOU_HAVE_NO_NOTIFICATIONS: "you have no notifications",
    NO_REVIEWS_YET: "no reviews yet",
    WRITE_A_REVIEW: "write a review",
    WRITING_A_REVIEW: "writing a review",
    ORDER_ID: "Order ID",
    PAGE_NOT_FOUND: "page not found",
    "IT_LOOKS_LIKE_THE_PAGE_...":
      "It looks like the page you're looking for has moved to a new address. But don't worry, we'll help you find your way back!",
    HOME: "home",
    RETURN_TO_THE_MAIN_PAGE: "return to the main page",
    CALCULATE: "calculate",
    CALCULATE_THE_COST_OF_MOVING: "calculate the cost of moving",
    GO_TO: "go to",
    PERSONAL_DATA_UPDATED: "personal data updated",
    FAILED_TO_UPDATE_PERSONAL_DATA: "failed to update personal data",
    ROLE_DATA_UPDATED: "role data updated",
    FAILED_TO_UPDATE_ROLE_DATA: "failed to update role data",
    PAID: "paid",
    UNPAID: "unpaid",
    ONLY_IMAGES_IN_JPG_PNG_SVG_FORMATS_ARE_ACCEPTED:
      "only images in {{formats}} formats are accepted",
    FAILED_TO_SAVE_IMAGE: "failed to save image",
    FAILED_TO_DELETE_PREVIOUS_IMAGE: "failed to delete previous image",
    ARE_YOU_SURE_YOU_WANT_TO_CLEAR_FORM_DATA: "Are you sure you want to clear form data?",
    MAX: "max",
    REVIEW_DETAILS: "review details",
    ORDER_NUMBER: "order number",
    "NO.": "No.",
    OPEN_NAVIGATION_MENU: "open navigation menu",
    CLOSE_NAVIGATION_MENU: "close navigation menu",
    PLEASE_PROVIDE_THIS_INFORMATION_ONLY_IF_YOU_WOULD_LIKE_US_TO_CONTACT_YOU:
      "Please provide this information only if you would like us to contact you.",
    THIS_INFORMATION_WILL_NOT_BE_AVAILABLE_PUBLICLY:
      "This information will not be available publicly.",
    OPTIONAL: "optional",
    PLEASE_PROVIDE_AT_LEAST_ONE_CONTACT_INFORMATION:
      "please provide at least one contact information",
    ORDER_DETAILS: "order details",
    ORDER_SUMMARY: "order summary",
    CUSTOMER_SUPPORT: "customer support",
    APPROVED: "approved",
    REJECTED: "rejected",
    APPROVE: "approve",
    DISAPPROVE: "disapprove",
    REVIEW_SUCCESSFULLY_APPROVED: "review successfully approved",
    FAILED_TO_APPROVE_REVIEW: "failed to approve review",
    MY_ORDERS: "my orders",
    DELETE_ALL: "delete all",
    "THIS_IS_SIMPLY_A_LIST_OF_ORDERS...":
      "This is simply a list of orders saved on your device, so you can view detailed information about each one at any time.",
    "DELETING_A_SPECIFIC_OR_ALL_ORDERS...":
      "Deleting a specific or all orders only deletes that data from your device and does not affect the data stored in the database.",
    "IF_YOU_NEED_TO_CHANGE_ANY_INFORMATION...":
      "If you need to change any information about your order or cancel it, please contact us.",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_ALL_ORDERS: "Are you sure you want to delete all orders?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_ORDER_N: "Are you sure you want to delete order #{{number}}?",
    YOU_HAVEN_T_CREATED_ANY_ORDERS_YET: "you haven't created any orders yet",
    "YOUR_REVIEW_WILL_BE_PUBLISHED_AFTER...":
      "your review will be published after verification by the administrator",
    CHANGE_PASSWORD: "change password",
    PASSWORD_CHANGE: "password change",
    CURRENT_PASSWORD: "current password",
    NEW_PASSWORD: "new password",
    REPEAT_NEW_PASSWORD: "repeat new password",
    PASSWORDS_DO_NOT_MATCH: "passwords do not match",
    PASSWORD_CHANGED: "password changed",
    FAILED_TO_CHANGE_PASSWORD: "failed to change password",
    CURRENT_PASSWORD_IS_INCORRECT: "current password is incorrect",
    INSUFFICIENT_RIGHTS_TO_PERFORM_THIS_ACTION: "insufficient rights to perform this action",
    CASH_PAYMENT_IS_POSSIBLE: "cash payment is possible",
    WE_HAVE_SPECIAL_OFFERS_FOR_SENIORS: "we have special offers for seniors",
    WE_PROVIDE_A_10_DISCOUNT_FOR_STUDENTS: "we provide a 10% discount for students",
    ABOUT_US: "about us",
    PASSWORD_RESET: "password reset",
    "ENTER_THE_EMAIL_ADDRESS_ASSOCIATED_WITH_YOUR_ACCOUNT...":
      "enter the email address associated with your account and we'll send you an email with a new password",
    RESET_PASSWORD: "reset password",
    PASSWORD_RESET_SUCCESSFUL: "password reset successful",
    AN_EMAIL_WITH_A_NEW_PASSWORD_HAS_BEEN_SENT_TO_YOUR_ADDRESS:
      "an email with a new password has been sent to your address",
    FAILED_TO_SEND_PASSWORD_RESET_REQUEST: "failed to send password reset request",
    AN_ACCOUNT_WITH_THE_SPECIFIED_EMAIL_ADDRESS_WAS_NOT_FOUND:
      "an account with the specified email address was not found",
    ABOUT_US_CHAPTER_1_TITLE: "YOUR HOME - OUR JOB",
    ABOUT_US_CHAPTER_1_PARAGRAPH:
      "We make sure your move goes smoothly. Whether you're moving to a new city, moving into your first home, or need more space with your family – <strong>we make your move easy and, above all, stress-free</strong>.",
    ABOUT_US_CHAPTER_2_TITLE: "YOUR COMPANY - OUR JOB",
    ABOUT_US_CHAPTER_2_PARAGRAPH_1:
      "<strong>Moving with a company can be a big challenge</strong>.",
    ABOUT_US_CHAPTER_2_PARAGRAPH_2:
      "That's why it's helpful to have a competent and experienced partner at your side. We specialize in carrying out corporate relocations efficiently and with minimal downtime. You focus on your core business, and we'll take care of the rest.",
    ABOUT_US_CHAPTER_3_TITLE: "DISPOSALS",
    ABOUT_US_CHAPTER_3_PARAGRAPH_1: "<strong>Make space without stress</strong>.",
    ABOUT_US_CHAPTER_3_PARAGRAPH_2:
      "Old furniture, electrical appliances, or broken items? Whatever needs to be disposed of, we'll take care of it for you in an <strong>environmentally friendly and professional manner</strong>. Whether it's after a move, a house clearance, or because you need more space – we'll make sure everything is disposed of properly.",
    ABOUT_US_CHAPTER_4_TITLE: "ABOUT HEGI UMZÜGE",
    ABOUT_US_CHAPTER_4_PARAGRAPH_1:
      "We are a young, energetic team striving to become a reliable partner in the relocation industry. Although we were only recently founded, we have a wealth of experience gained working with leading companies in the industry. We know how to organize a move so that it is quick, safe, and stress-free for our customers.",
    ABOUT_US_CHAPTER_4_PARAGRAPH_2:
      "By founding our own company, we've combined best practices and ideas to take our service to the next level. Our goal isn't just to move things, but to give people confidence and security during a crucial phase of their lives. We grow, we learn, and we improve every day – for the benefit of those who entrust us with their move.",
    SHOW_MY_ORDERS: "show my orders",
    HIDE_MY_ORDERS: "hide my orders",
    QR_CODE_TO_GO_TO_THIS_SITE: "QR code to go to this site",
    ALL_SERVICES_BELONGING_TO_THIS_CATEGORY_WILL_BE_DELETED:
      "all services belonging to this category will be deleted",
    THE_ORDER_CANNOT_BE_UPDATED_BECAUSE_IT_HAS_ALREADY_BEEN_FULFILLED:
      "the order cannot be updated because it has already been fulfilled",
    CHANGE_OF_STATUS: "change of status",
    THE_ORDER_STATUS_IS_COMPLETED_ARE_YOU_SURE_YOU_WANT_TO_CHANGE_IT_TO_NEW:
      'The order status is "{{current}}." Are you sure you want to change it to "{{new}}"?',
    CHANGE_PAYMENT_STATUS: "change payment status",
    PAYMENT_STATUS_CHANGE: "payment status change",
    PAYMENT_STATUS_CHANGED: "payment status changed",
    FAILED_TO_CHANGE_PAYMENT_STATUS: "failed to change payment status",
    MOST_LIKELY_IT_WAS_DELETED: "most likely it was deleted",
    SETTINGS: "settings",
    CLOSE: "close",
    CONSENT_MODAL_TITLE: "we use cookies",
    CONSENT_MODAL_DESCRIPTION:
      "We use cookies to operate our website and to display and analyze ads through Google Ads. Essential cookies are always used. All other cookies are used only with your consent. You can accept all cookies, reject optional ones, or customize your preferences.",
    CONSENT_MODAL_ACCEPT_ALL: "accept all",
    CONSENT_MODAL_ACCEPT_NECESSARY: "accept only essential",
    CONSENT_PREFERENCES_MODAL_TITLE: "cookie settings",
    CONSENT_PREFERENCES_MODAL_SAVE_PREFERENCES: "accept",
    CONSENT_PREFERENCES_MODAL_SERVICE: "service(s)",
    CONSENT_PREFERENCES_MODAL_SECTION_NECESSARY_TITLE: "necessary",
    CONSENT_PREFERENCES_MODAL_SECTION_NECESSARY_DESCRIPTION:
      "These cookies are necessary for the website to function properly, for example, to authenticate users.",
    CONSENT_PREFERENCES_MODAL_SECTION_ANALYTICS_TITLE: "analytics",
    CONSENT_PREFERENCES_MODAL_SECTION_ANALYTICS_DESCRIPTION:
      "Cookies used for analytics help collect data that allows services to understand how users interact with a particular service.",
    CONSENT_PREFERENCES_MODAL_SERVICE_ANALYTICS_STORAGE:
      "Allows storing data (such as cookies) related to analytics, such as the duration of your visit.",
    CONSENT_PREFERENCES_MODAL_SECTION_ADVERTISING_TITLE: "advertising",
    CONSENT_PREFERENCES_MODAL_SECTION_ADVERTISING_DESCRIPTION:
      "Google uses cookies for advertising purposes, including displaying and delivering ads, personalizing ads, limiting the number of times you see an ad, turning off ads you choose not to see, and measuring ad effectiveness.",
    CONSENT_PREFERENCES_MODAL_SERVICE_AD_STORAGE:
      "Allows storing data (such as cookies) related to advertising.",
    CONSENT_PREFERENCES_MODAL_SERVICE_AD_USER_DATA:
      "Allows sending advertising-related user data to Google.",
    CONSENT_PREFERENCES_MODAL_SERVICE_AD_PERSONALIZATION:
      "Allows the use of data for personalized advertising.",
    CONSENT_PREFERENCES_MODAL_SECTION_FUNCTIONALITY_TITLE: "functionality",
    CONSENT_PREFERENCES_MODAL_SECTION_FUNCTIONALITY_DESCRIPTION:
      "Functional cookies enable users to interact with a service or website to access features that are fundamental to that service.",
    CONSENT_PREFERENCES_MODAL_SERVICE_FUNCTIONALITY_STORAGE:
      "Enables storage that supports website or application functionality, such as language settings.",
    CONSENT_PREFERENCES_MODAL_SERVICE_PERSONALIZATION_STORAGE:
      "Enables storage for personalization-related data such as recommendations.",
    CONSENT_PREFERENCES_MODAL_SECTION_SECURITY_TITLE: "security",
    CONSENT_PREFERENCES_MODAL_SECTION_SECURITY_DESCRIPTION:
      "Cookies used for security purposes, such as authenticating users, preventing fraud, and protecting users when interacting with the service.",
    CONSENT_PREFERENCES_MODAL_SERVICE_SECURITY_STORAGE:
      "Enables storage for security-related data such as authentication, fraud prevention, and other user protection features.",
    THE_PAGE_LANGUAGE_HAS_CHANGED_BUT_THE_CONTENTS:
      "The page language has changed, but the contents of the cookie dialog box will only be updated after the page is reloaded.",
    IF_YOU_ARE_NOT_INTERESTED_IN_THE_CONTENTS:
      "If you are not interested in the contents of the cookie dialog box, you can ignore this message.",
    RELOAD_PAGE: "reload the page",
    CONSENT_SUMMARY_TITLE: "consent status for data processing",
    CONSENT_SUMMARY_DESCRIPTION:
      "A quick overview of your current consent status. Detailed information is available in settings.",
    CONSENT_ID: "consent ID",
    LAST_MODIFIED: "last modified",
    CONSENT_SUMMARY_ALLOWED: "allowed",
    CONSENT_SUMMARY_PARTIALLY_ALLOWED: "partially allowed",
    CONSENT_SUMMARY_BLOCKED: "blocked",
  } satisfies Record<Tk, string>,
} satisfies ResourceLanguage;

export { RESOURCES };
